import { Observable } from 'rxjs';

import { User } from '../../../domain/user/user';
import { ObserveSearchedCoachesIncludingPartnersQuery } from '../query/observe-searched-coaches-including-partners.query';

export abstract class UserRepositoryPort {
	public abstract observeUserById(id: string): Observable<User>;

	public abstract saveUsers(users: User[]): Promise<void>;

	public abstract observeSearchedCoachesIncludingPartners(
		query: ObserveSearchedCoachesIncludingPartnersQuery
	): Observable<User[]>;

	public abstract observeUsersByCoachId(coachId: string): Observable<User[]>;

	public abstract findById(userId: string): Promise<User>;

	public abstract observeUserByIds(ids: string[]): Observable<User[]>;

	public abstract observeCoacheesWithoutCoach(
		organizationsId: string[]
	): Observable<User[]>;

	public abstract removeUserCoach(userId: string): void;
}
